export const payrollSettingsTabList = [
  {
    label: "Salary Breakdown",
    link: "/admin/settings/payroll",
  },
  {
    label: "Pay Components",
    link: "/admin/settings/payroll/pay-components",
  },
  {
    label: "Pay Schedule",
    link: "/admin/settings/payroll/pay-schedule",
  },
  {
    label: "Tax Setting",
    link: "/admin/settings/payroll/tax-setting",
  },
];
